import { AccountProvider } from '@collinsonx/constants/enums';
import usePayload from 'hooks/usePayload';
import Head from 'next/head';
import { ReactNode } from 'react';

const { LK } = AccountProvider;

export default function MetadataWrapper({ children }: { children: ReactNode }) {
  const { payload } = usePayload();

  return (
    <>
      <Head>
        <title>Booking</title>
        <meta
          content="minimum-scale=1, initial-scale=1, width=device-width"
          name="viewport"
        />
        <link
          href={
            payload?.accountProvider === LK
              ? '/lk-favicon.ico'
              : '/pp-favicon.ico'
          }
          rel="icon"
          sizes="any"
        />
      </Head>
      {children}
    </>
  );
}
